module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fABc4AMP6lbBP.d40a48c2.woff2";